import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "top-header-area bg-grey-teal" }
const _hoisted_2 = { class: "container mw-1685" }
const _hoisted_3 = { class: "ptb-11" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-lg-4" }
const _hoisted_6 = { class: "d-flex justify-content-center justify-content-lg-end align-items-center" }
const _hoisted_7 = { class: "login-register" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"col-lg-8\"><ul class=\"ps-0 mb-0 list-unstyled info-link style-two d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start position-relative tops-1\"><li><a href=\"tel:+0013213456\"><i class=\"ti ti-phone-call\"></i> اتصل بنا: +001 321 3456 </a></li><li><a href=\"mailto:support@nestor.com\"><i class=\"ti ti-mail\"></i> البريد الإلكتروني: support@nestor.com </a></li><li><i class=\"ti ti-map-pin\"></i> الموقع: 1485 Bayshore Blvd. Ste 154, San Francisco, CA 95124 </li></ul></div>", 1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_RouterLink, { to: "/login" }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("تسجيل الدخول", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_RouterLink, {
                  to: "/register",
                  class: ""
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("إنشاء حساب", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[2] || (_cache[2] = _createStaticVNode("<ul class=\"ps-0 mb-0 list-unstyled d-flex flex-wrap align-items-center social-link\"><li><a href=\"https://www.facebook.com/\" target=\"_blank\"><i class=\"ri-facebook-fill\"></i></a></li><li><a href=\"https://www.twitter.com/\" target=\"_blank\"><i class=\"ri-twitter-x-line\"></i></a></li><li><a href=\"https://www.instagram.com/\" target=\"_blank\"><i class=\"ri-instagram-fill\"></i></a></li><li><a href=\"https://www.linkedin.com/\" target=\"_blank\"><i class=\"ri-linkedin-fill\"></i></a></li></ul>", 1))
            ])
          ])
        ])
      ])
    ])
  ]))
}